import React, { Component } from 'react';
import { Button, Modal } from "react-bootstrap";

class AboutModal extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
            show: false
        };
    }

    handleClose() {
        this.setState({ show: false });
    }

    handleShow() {
        this.setState({ show: true });
    }

    render() {
        var date = new Date();
        return (
            <div>
                <i onClick={this.handleShow} className="fas fa-question-circle pull-right"></i>

                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Body>
                        <h1>It's just satire!</h1>
                        <p>Formula One isn't a spec series, which makes driver ranking difficult and highly subjective. While the best drivers will naturally migrate to the top teams, comparing drivers who have never been teammates remains a challenge.</p>
                        <p>While it's possible to draw some rudimentary conclusions from transitive teammate comparisons, they are generally too simplistic to capture the nuance of the sport.</p>
                        <div className="quote">
                            Because the mechanisms driving comparisons do not remain static in something as complex as F1, so the reality of relative performance driver-to-driver is forever changing. In getting an accurate reading on this, it pays not to be too dogmatic.
                            <div className="author">- Mark Hughes</div>
                        </div>
                        <p>When applied excessively and without proper context, the technique can result in some absurd conclusions.</p>
                        <p>So, on that note, see what you can come up with.</p>
                        <p>u/kj-ka-</p>
                        <div className="button-wrapper">
                            <Button id="close" onClick={this.handleClose}><i className="fas fa-times"></i>Close</Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default AboutModal;